<template>
  <footer class="website-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
        </div>
        <div class="footer-right">
        </div>
      </div>

      <div class="footer-bottom">
        <p>{{ t('footer.copyright') }}</p>
        <p class="beian-info">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
            浙ICP备2025178566号-1
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bitter:wght@300;400;500;600;700&family=Hind:wght@300;400;500;600;700&display=swap');

.website-footer {
  background-color: #1a1a1a;
  color: #ccc;
  padding: 60px 0 30px;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 50px;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 45px;
  border-bottom: 1px solid #333;
}

.logo-img {
  height: 120px;
  width: auto;
  transition: transform 0.3s ease;
  object-fit: contain;
}

.logo-img:hover {
  transform: scale(1.05);
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 30px;
}

.lang-switcher {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.08);
  padding: 10px 22px;
  border-radius: 28px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1.5px solid rgba(255, 255, 255, 0.1);
}

.lang-switcher:hover {
  background-color: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
}

.flag-icon {
  width: 26px;
  height: 19px;
  object-fit: cover;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.lang-text {
  font-size: 15px;
  font-weight: 700;
  color: white;
  font-family: 'Segoe UI', sans-serif;
  letter-spacing: 0.5px;
}

.dropdown-icon {
  color: #a0aec0;
  transition: transform 0.3s ease;
}

.dropdown-icon.rotate {
  transform: rotate(180deg);
}

.lang-dropdown {
  position: absolute;
  bottom: calc(100% + 10px);
  right: 0;
  background-color: #2a2a2a;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  min-width: 180px;
  animation: slideUp 0.3s ease;
  border: 1px solid #444;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  color: #e0e0e0;
  font-family: 'Segoe UI', sans-serif;
}

.lang-option:hover {
  background-color: rgba(33, 150, 243, 0.15);
}

.lang-option.active {
  background-color: rgba(33, 150, 243, 0.25);
  color: #2196F3;
  font-weight: 600;
}

.lang-option:not(:last-child) {
  border-bottom: 1px solid #333;
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
}

.footer-bottom p {
  margin: 0;
  font-size: 14px;
  font-family: 'Hind', sans-serif;
  color: #888;
}

.beian-info {
  margin-top: 10px;
}

.beian-link {
  color: #888;
  text-decoration: none;
  transition: color 0.3s ease;
  pointer-events: auto;
  cursor: pointer;
  display: inline-block;
}

.beian-link:hover {
  color: #2196F3;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }

  .footer-content {
    flex-direction: row;
    gap: 20px;
    text-align: left;
    align-items: flex-start;
  }

  .footer-logo {
    flex: 0 0 auto;
  }

  .logo-img {
    height: 80px;
  }

  .footer-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

  .lang-switcher {
    padding: 8px 18px;
  }

  .website-footer {
    padding: 50px 0 30px;
  }
}
</style>
